import React from "react"
import './Suggestion.css'

interface Props
{
	key?: number
	place?: string
}

const Suggestion = (props: Props) =>
{
	return (
		<div className="d-flex align-items-center suggestion-container">
			<img src="../assets/gps.png" alt="" />
			<div className="suggestion-text">{props.place}</div>
		</div>
	)
}

export default Suggestion